"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var localStorage_1 = __importDefault(require("../../config/localStorage"));
var org_hook_1 = require("../../context/OrgContext/org.hook");
var userContext_1 = require("../../context/UserContext/userContext");
var roles_1 = require("../../router/roles");
var icons_1 = __importDefault(require("../icons"));
var LanguageContainer_1 = __importDefault(require("../navbar/LanguageContainer"));
function HeaderContent() {
    var _this = this;
    var _a = (0, react_1.useContext)(userContext_1.UserContext), user = _a.user, setCurrentUser = _a.setCurrentUser, setCurrentOrganization = (0, org_hook_1.useOrg)().setCurrentOrganization, history = (0, react_router_dom_1.useHistory)(), onLogoutClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.clear()];
                case 1:
                    _a.sent();
                    setCurrentUser({});
                    setCurrentOrganization({});
                    history.push("/");
                    location.reload();
                    return [2 /*return*/];
            }
        });
    }); };
    var onBack = function () { return __awaiter(_this, void 0, void 0, function () {
        var item, filtredRole;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("user")];
                case 1:
                    item = _a.sent();
                    filtredRole = item.roles.filter(function (l) {
                        return roles_1.roles.admins.includes(l.name);
                    });
                    if (filtredRole && filtredRole.length > 0) {
                        history.replace("/admin/dashboard");
                    }
                    else {
                        history.replace("/agent/dashboard");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "header-content" },
        react_1.default.createElement("div", { className: "header-logo" },
            react_1.default.createElement("div", { onClick: function () {
                    onBack();
                    // history.replace("/agent/dashboard")
                } },
                react_1.default.createElement(icons_1.default, { className: "icon", height: 40, name: "backArrow", width: 40 })),
            react_1.default.createElement("div", { onClick: function () {
                    onBack();
                } },
                react_1.default.createElement(icons_1.default
                // className="icon_black"
                , { 
                    // className="icon_black"
                    height: 80, name: "hclogowhite", width: 120 }))),
        react_1.default.createElement("div", { className: "header-logo" },
            react_1.default.createElement("a", { className: "headerText language-header-text" }, user && user.name),
            react_1.default.createElement("div", { style: {
                    marginLeft: "3vw",
                    marginRight: "1vw",
                } },
                react_1.default.createElement(LanguageContainer_1.default, { className: "language-header-text", iconClassName: "icon" })),
            react_1.default.createElement("div", { onClick: function () { return onLogoutClick(); } },
                react_1.default.createElement(icons_1.default, { className: "icon", height: 50, name: "logOut", width: 50 })))));
}
exports.default = HeaderContent;
